/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2018, 2019
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { getGroupLabel } from './RelationshipUtil';

const ITEMCLASS_FROM_UID = 'From';
const ITEMCLASS_TO_UID = 'To';
const ITEMCLASS_STRENGTH_UID = 'Strength';
const ITEMCLASS_AGGREGATE_SUM = 'sum';

/**
* This class converts the Predict Response of smart explore service into the Query Result Data structure
* that can be used to populate VIPRDATA
**/
export default class LinkDataset {
	constructor(rawData, metadataInfo, options) {
		this.dataset = rawData && rawData.relationshipStrength && rawData.relationshipStrength.results ? rawData.relationshipStrength.results[0].relationships:[];
		this.metadataInfo = metadataInfo;
		this.options = options;
		this._resetData();
	}

	_resetData(){
		this._fromItemsList = [];//Array that stores the virtual 'From' column data items
		this._toItemsList = [];//Array that stores the virtual 'To' column data items
		this.dataPoints = [];//Array that stroes the datapoints array
	}

	_createItemClass_from(){
		return { 'itemClass': {
			'h': [{
				'u': ITEMCLASS_FROM_UID,
				'd': ITEMCLASS_FROM_UID
			}]
		} };
	}

	_createItemClass_to(){
		return { 'itemClass': {
			'h': [{
				'u': ITEMCLASS_TO_UID,
				'd': ITEMCLASS_TO_UID
			}]
		} };
	}

	/**
	* Create a single data item JSON object using the passed in data item ID
	*
	* @param {String} Item unique name
	**/
	createSingleItem(groupUid){
		return {
			't': [{
				'u': groupUid,
				'd': getGroupLabel(groupUid, this.metadataInfo)
			}]
		};
	}

	_createItemClass_strength(){
		return { 'itemClass': {
			'h': [{
				'u': ITEMCLASS_STRENGTH_UID,
				'd': ITEMCLASS_STRENGTH_UID,
				'aggregate': ITEMCLASS_AGGREGATE_SUM
			}]
		} };
	}

	/**
	* Add one data item to the 'From' or 'To' data items list
	*
	* @param {String} itemId  The unique ID of the data item to be added
	* @param {Array of JONObject} itemList  Array that holds the data items for either 'From' or 'To' columns
	**/
	addSingleItem(groupUid,itemsList){
		let bFound = false;
		let nIndex = -1;
		itemsList.some((itemEntry, itemIndex)=>{
			if(itemEntry.t[0].u === groupUid){//Group has only one tuple
				bFound = true;
				nIndex = itemIndex;
				return bFound;
			}
		});
		if(nIndex === -1){
			nIndex = itemsList.push(this.createSingleItem(groupUid)) - 1;
		}
		return nIndex;
	}

	/**
	* Add one data point
	*
	* @param {Number} fromIndex
	* @param {Number} toIndex
	* @param {value} value	Strength column value
	**/
	addDatapoint(fromIndex, toIndex, value){
		this.dataPoints.push({ pt : [fromIndex, toIndex, { v:value }] });
	}

	/**
	* @return The converted JSON Object that can be consumed directly to create VIPRDATA
	*/
	getLinkDatasetQueryResult(){
		this.dataset.forEach((entry)=>{
			let nFromIndex, nToIndex = null;
			// If relationship is primary, make sure the target node is on FROM node side to have pretty arc in diagram (VIDA recommendation)
			if (entry.fieldA === this.options.targetId || entry.fieldB !== this.options.targetId) {
				nFromIndex = this.addSingleItem(entry.a, this._fromItemsList);
				nToIndex = this.addSingleItem(entry.b, this._toItemsList);
			} else {
				nFromIndex = this.addSingleItem(entry.b, this._fromItemsList);
				nToIndex = this.addSingleItem(entry.a, this._toItemsList);
			}
			this.addDatapoint(nFromIndex, nToIndex, entry.strength);
		});
		const oFromItemsSection = Object.assign(this._createItemClass_from(), { items: this._fromItemsList });
		const oToItemsSection = Object.assign(this._createItemClass_to(), { items: this._toItemsList });
		const oDataItems = { 'dataItems': [oFromItemsSection, oToItemsSection, this._createItemClass_strength()] };
		return Object.assign( oDataItems, { 'data': this.dataPoints } );
	}
}



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/LinkDataset.js